import React, { useEffect } from "react";
import "../App.css";
import Partners from "../components/Partners";
import FirstChoice from "../components/FirstChoice";
import HeadingCAT from "../components/HeadingCAT";
import ProductSection from "../components/ProductSection";
import Header from "../components/Header";
import Bestprovider from "../components/Bestprovider";
import QuotePolicies from "../components/QuotePolicies";
import Anniversary from "../components/Anniversary";

/**
 * Index page
 * This page is purposefly for downloading all forms data
 * @returns a JSX components that makes up the homepage
 */

function Home() {
  useEffect(() => {
    const elements = document.querySelectorAll(".scroll-reveal");

    const observer = new IntersectionObserver(
      (entries, obs) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
            obs.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.2 }
    );

    elements.forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <div className="Home">
      {/* Nav *
      <Navbar /> */}
      {/* Header */}
      <Header />
      {/* First Choice Caption */}
      <FirstChoice Title="FIRST CHOICE" />
      {/* Anniversary */}
      <Anniversary />
      {/* Heading */}
      <HeadingCAT className="scroll-reveal reveal-right" />
      {/* Highlighted Products */}
      <ProductSection />
      {/* ssssssss */}
      {/* <FreeQuote className="doNotShowOnMobile" /> */}
      <FirstChoice Title="GET A QUOTE" className="scroll-reveal reveal-left" />
      {/* Request a free quote */}
      <QuotePolicies />
      {/* Request a free quote */}{" "}
      {/*
      <QuotePoliciesAction /> */}
      {/* First Choice Caption */}
      {/* <FirstChoice Title="BEST PROVIDER" style={{margin: '100px 0px 0px 0px'}} />  */}
      <Bestprovider />
      {/* Partners */}
      <Partners />
      {/* <FaqNAbout /> */}
      {/* Footer *
      <Footer /> */}
    </div>
  );
}

export default Home;
